import { useCallback } from 'react';
import { useLogger, useAppshellMeta, useAppBridge } from '@ids/appshell/hooks';
import { isClient } from '@ids/helpers';

interface UseCustomEventReturnType {
    openNativePDP: (sku: string) => void;
    openNativeOverlay: (url: string) => void;
}

const useCustomEvent = (): UseCustomEventReturnType => {
    const AppBridge = useAppBridge();
    const logger = useLogger();
    const { isApp } = useAppshellMeta();

    const appBridge = isClient() ? AppBridge.getInstance(logger) : null;

    const openNativePDP = useCallback(
        (sku: string) => {
            if (!isApp || !appBridge) {
                return;
            }

            appBridge.sendShowProductEvent(sku);
        },
        [appBridge, isApp]
    );

    const openNativeOverlay = useCallback(
        (url: string) => {
            if (!isApp || !appBridge) {
                return;
            }

            appBridge.sendShowOverlay(url);
        },
        [appBridge, isApp]
    );

    return { openNativePDP, openNativeOverlay };
};

export default useCustomEvent;
